import React, { useState } from 'react';
import { DetailPanelData, DetailPanelButton, DetailPanelGroup } from '../../../Common/DetailPanel';
import { FormatDate } from '../../../../utils';

const ManufacturerInformation = ({
    data: {
        manufacturerName = '',
        tagNumber = null,
        serialNumber = null,
        modelNumber = '',
        manufactureDate = '',
        modelYear = null,
        temperatureClassName = '',
        hermeticallySealed = null,
        coolingCapacity = '',
        seer = '',
        eer = '',
        eseer = '',
        oilType = null,
        poNumber = null,
        lifeTime = null,
        amps = null,
        voltage = null,
        hertz = null,
        phase = null,
        systemManagerName = null,
        energySourceTypeName = '',
        ratedCoilTemperature = '',
        brand = ''
    } = {},
}) => {
    const [show, setShow] = useState(false);

    return (
        <>
            {manufacturerName !== '' && <DetailPanelData id='ManufacturerNameHeader' title="MANUFACTURER NAME" data={manufacturerName} />}
            {modelNumber !== '' && <DetailPanelData id='ModelNumberHeader' title="MODEL NUMBER" data={modelNumber} />}
            <DetailPanelData id='TemperatureClassHeader' title="TEMPERATURE CLASS" data={temperatureClassName} />
            {tagNumber !== null && <DetailPanelData id='TagNumberHeader' title="TAG NUMBER" data={tagNumber} />}
            {manufactureDate !== '' && <DetailPanelData id='ManufactureDateHeader' title="MANUFACTURER DATE" data={FormatDate(manufactureDate)} />}
            {serialNumber !== null && <DetailPanelData id='SerialNumberHeader' title="SERIAL NUMBER" data={serialNumber} />}
            {modelYear !== null && <DetailPanelData id='ModelYearHeader' title="MODEL YEAR" data={modelYear} />}
            <DetailPanelButton isVisible={!show} text={"View More"} onClick={() => setShow(prev => !prev)} />
            {
                show && (
                    <DetailPanelGroup>
                        {eseer !== '' && <DetailPanelData id='ESEERHeader' title="ESEER" data={eseer} />}
                        {voltage !== null && <DetailPanelData id='voltage' title="VOLTAGE" data={voltage} />}
                        {hermeticallySealed !== null && <DetailPanelData id='hermeticallySealed' title="HERMETICALLY SEALED" data={hermeticallySealed == true ? 'Yes' : 'No'} />}
                        {oilType !== null && <DetailPanelData id='OilTypeHeader' title="OIL TYPE" data={oilType} />}
                        {hertz !== null && <DetailPanelData id='hertz' title="HERTZ" data={hertz} />}
                        {coolingCapacity !== '' && <DetailPanelData id='CoolingCapacityHeader' title="COOLING CAPACITY" data={coolingCapacity} />}
                        {brand !== '' && <DetailPanelData id='brandHeader' title="BRAND" data={brand} />}
                        {phase !== null && <DetailPanelData id='phase' title="PHASE" data={phase} />}
                        {ratedCoilTemperature !== '' && <DetailPanelData id='ratedCoilTempHeader' title="RATED COIL TEMPERATURE (F)" data={ratedCoilTemperature} />}
                        {poNumber !== null && <DetailPanelData id='PONumberHeader' title="PO NUMBER" data={poNumber} />}
                        {systemManagerName !== null && <DetailPanelData id='systemManagerName' title="SYSTEM MANAGER" data={systemManagerName} />}
                        {seer !== '' && <DetailPanelData id='SEERHeader' title="SEER" data={seer} />}
                        {lifeTime !== null && <DetailPanelData id='ExpectedLifeHeader' title="EXPECTED LIFE (YEARS)" data={lifeTime} />}
                        {energySourceTypeName !== '' && <DetailPanelData id='energySourceTypeHeader' title="ENERGY SOURCE TYPE" data={energySourceTypeName} />}
                        {eer !== '' && <DetailPanelData id='EERHeader' title="EER" data={eer} />}
                        {amps !== null && <DetailPanelData id='amps' title="AMPS" data={amps} />}
                        <DetailPanelButton isVisible={show} text={"View Less"} onClick={() => setShow(prev => !prev)} />
                    </DetailPanelGroup>
                )
            }
        </>
    )
}

export default ManufacturerInformation;